import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _688133b0 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _c7fcfb20 = () => interopDefault(import('../pages/documents.vue' /* webpackChunkName: "pages/documents" */))
const _2f51bd60 = () => interopDefault(import('../pages/documents/_area/index.vue' /* webpackChunkName: "pages/documents/_area/index" */))
const _3224f0c4 = () => interopDefault(import('../pages/messages.vue' /* webpackChunkName: "pages/messages" */))
const _72c2d447 = () => interopDefault(import('../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _0d4bff57 = () => interopDefault(import('../pages/messages/create.vue' /* webpackChunkName: "pages/messages/create" */))
const _1a06d3fb = () => interopDefault(import('../pages/messages/inbox.vue' /* webpackChunkName: "pages/messages/inbox" */))
const _fc0dd69a = () => interopDefault(import('../pages/messages/sent.vue' /* webpackChunkName: "pages/messages/sent" */))
const _37dfa0e1 = () => interopDefault(import('../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _0bce3aa4 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _799ac6f8 = () => interopDefault(import('../pages/profile/settings/index.vue' /* webpackChunkName: "pages/profile/settings/index" */))
const _67095988 = () => interopDefault(import('../pages/requests.vue' /* webpackChunkName: "pages/requests" */))
const _63337cbf = () => interopDefault(import('../pages/requests/index.vue' /* webpackChunkName: "pages/requests/index" */))
const _635b9ee0 = () => interopDefault(import('../pages/requests/new/index.vue' /* webpackChunkName: "pages/requests/new/index" */))
const _bcd96430 = () => interopDefault(import('../pages/requests/submitted.vue' /* webpackChunkName: "pages/requests/submitted" */))
const _48ed5752 = () => interopDefault(import('../pages/requests/new/_type.vue' /* webpackChunkName: "pages/requests/new/_type" */))
const _5ed5190a = () => interopDefault(import('../pages/auth/impersonate.vue' /* webpackChunkName: "pages/auth/impersonate" */))
const _577100ba = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _387fc1ee = () => interopDefault(import('../pages/auth/logout.vue' /* webpackChunkName: "pages/auth/logout" */))
const _2fad85fb = () => interopDefault(import('../pages/auth/registration/index.vue' /* webpackChunkName: "pages/auth/registration/index" */))
const _6f9b91f2 = () => interopDefault(import('../pages/auth/t2t.vue' /* webpackChunkName: "pages/auth/t2t" */))
const _51157d7a = () => interopDefault(import('../pages/download/document.vue' /* webpackChunkName: "pages/download/document" */))
const _23ddec95 = () => interopDefault(import('../pages/idAustriaSp/callback.vue' /* webpackChunkName: "pages/idAustriaSp/callback" */))
const _dd47f6f6 = () => interopDefault(import('../pages/idAustriaSp/confirmation.vue' /* webpackChunkName: "pages/idAustriaSp/confirmation" */))
const _33026e6e = () => interopDefault(import('../pages/idAustriaSp/verify.vue' /* webpackChunkName: "pages/idAustriaSp/verify" */))
const _eb112520 = () => interopDefault(import('../pages/auth/registration/update.vue' /* webpackChunkName: "pages/auth/registration/update" */))
const _5e886520 = () => interopDefault(import('../pages/auth/registration/verify.vue' /* webpackChunkName: "pages/auth/registration/verify" */))
const _6957045d = () => interopDefault(import('../pages/auth/reset/password/index.vue' /* webpackChunkName: "pages/auth/reset/password/index" */))
const _6a166e0a = () => interopDefault(import('../pages/auth/reset/user.vue' /* webpackChunkName: "pages/auth/reset/user" */))
const _1194a215 = () => interopDefault(import('../pages/auth/reset/username.vue' /* webpackChunkName: "pages/auth/reset/username" */))
const _3e4d383a = () => interopDefault(import('../pages/auth/sso/login.vue' /* webpackChunkName: "pages/auth/sso/login" */))
const _8edb8a10 = () => interopDefault(import('../pages/auth/sso/verify.vue' /* webpackChunkName: "pages/auth/sso/verify" */))
const _3b33982e = () => interopDefault(import('../pages/profile/settings/delete.vue' /* webpackChunkName: "pages/profile/settings/delete" */))
const _71b74a4e = () => interopDefault(import('../pages/profile/settings/email.vue' /* webpackChunkName: "pages/profile/settings/email" */))
const _6fb7bf59 = () => interopDefault(import('../pages/profile/settings/password.vue' /* webpackChunkName: "pages/profile/settings/password" */))
const _5a0eb2fe = () => interopDefault(import('../pages/auth/reset/password/verify.vue' /* webpackChunkName: "pages/auth/reset/password/verify" */))
const _204c4b8a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3a78a0ee = () => interopDefault(import('../pages/documents/detail/_id/index.vue' /* webpackChunkName: "pages/documents/detail/_id/index" */))
const _7dbd251a = () => interopDefault(import('../pages/messages/detail/_id/index.vue' /* webpackChunkName: "pages/messages/detail/_id/index" */))
const _171901a2 = () => interopDefault(import('../pages/requests/detail/_id/index.vue' /* webpackChunkName: "pages/requests/detail/_id/index" */))
const _05122497 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _688133b0,
    name: "account___de"
  }, {
    path: "/documents",
    component: _c7fcfb20,
    name: "documents___de",
    children: [{
      path: ":area",
      component: _2f51bd60,
      name: "documents-area___de"
    }]
  }, {
    path: "/messages",
    component: _3224f0c4,
    children: [{
      path: "",
      component: _72c2d447,
      name: "messages___de"
    }, {
      path: "create",
      component: _0d4bff57,
      name: "messages-create___de"
    }, {
      path: "inbox",
      component: _1a06d3fb,
      name: "messages-inbox___de"
    }, {
      path: "sent",
      component: _fc0dd69a,
      name: "messages-sent___de"
    }]
  }, {
    path: "/profile",
    component: _37dfa0e1,
    children: [{
      path: "",
      component: _0bce3aa4,
      name: "profile___de"
    }, {
      path: "settings",
      component: _799ac6f8,
      name: "profile-settings___de"
    }]
  }, {
    path: "/requests",
    component: _67095988,
    children: [{
      path: "",
      component: _63337cbf,
      name: "requests___de"
    }, {
      path: "new",
      component: _635b9ee0,
      name: "requests-new___de"
    }, {
      path: "submitted",
      component: _bcd96430,
      name: "requests-submitted___de"
    }, {
      path: "new/:type",
      component: _48ed5752,
      name: "requests-new-type___de"
    }]
  }, {
    path: "/auth/impersonate",
    component: _5ed5190a,
    name: "auth-impersonate___de"
  }, {
    path: "/auth/login",
    component: _577100ba,
    name: "auth-login___de"
  }, {
    path: "/auth/logout",
    component: _387fc1ee,
    name: "auth-logout___de"
  }, {
    path: "/auth/registration",
    component: _2fad85fb,
    name: "auth-registration___de"
  }, {
    path: "/auth/t2t",
    component: _6f9b91f2,
    name: "auth-t2t___de"
  }, {
    path: "/download/document",
    component: _51157d7a,
    name: "download-document___de"
  }, {
    path: "/idAustriaSp/callback",
    component: _23ddec95,
    name: "idAustriaSp-callback___de"
  }, {
    path: "/idAustriaSp/confirmation",
    component: _dd47f6f6,
    name: "idAustriaSp-confirmation___de"
  }, {
    path: "/idAustriaSp/verify",
    component: _33026e6e,
    name: "idAustriaSp-verify___de"
  }, {
    path: "/auth/registration/update",
    component: _eb112520,
    name: "auth-registration-update___de"
  }, {
    path: "/auth/registration/verify",
    component: _5e886520,
    name: "auth-registration-verify___de"
  }, {
    path: "/auth/reset/password",
    component: _6957045d,
    name: "auth-reset-password___de"
  }, {
    path: "/auth/reset/user",
    component: _6a166e0a,
    name: "auth-reset-user___de"
  }, {
    path: "/auth/reset/username",
    component: _1194a215,
    name: "auth-reset-username___de"
  }, {
    path: "/auth/sso/login",
    component: _3e4d383a,
    name: "auth-sso-login___de"
  }, {
    path: "/auth/sso/verify",
    component: _8edb8a10,
    name: "auth-sso-verify___de"
  }, {
    path: "/profile/settings/delete",
    component: _3b33982e,
    name: "profile-settings-delete___de"
  }, {
    path: "/profile/settings/email",
    component: _71b74a4e,
    name: "profile-settings-email___de"
  }, {
    path: "/profile/settings/password",
    component: _6fb7bf59,
    name: "profile-settings-password___de"
  }, {
    path: "/auth/reset/password/verify",
    component: _5a0eb2fe,
    name: "auth-reset-password-verify___de"
  }, {
    path: "/",
    component: _204c4b8a,
    name: "index___de"
  }, {
    path: "/documents/detail/:id",
    component: _3a78a0ee,
    name: "documents-detail-id___de"
  }, {
    path: "/messages/detail/:id",
    component: _7dbd251a,
    name: "messages-detail-id___de"
  }, {
    path: "/requests/detail/:id",
    component: _171901a2,
    name: "requests-detail-id___de"
  }, {
    path: "/requests/new/:type?",
    component: _48ed5752,
    name: "requests-new-type___de"
  }, {
    path: "/*",
    component: _05122497,
    name: "all___de"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
